import React, { useEffect, useState } from 'react'
import './Work.scss'
import { AiFillEye, AiFillGithub } from 'react-icons/ai'
import { motion, MotionConfig } from 'framer-motion'

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client'

const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All')
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 })
  const [works, setWorks] = useState([])
  const [filterWork, setFilterWork] = useState([])
  const [link, setLink] = useState();


  const handleItem = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }])
    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }])

      if (item === 'All')
        setFilterWork(works)
      else {
        setFilterWork(works.filter((work) => work.tags.includes(item)))
      }
    }, 500);
  }

  useEffect(() => {
    const query = '*[_type == "works"]'
    client.fetch(query)
      .then((data) => {
        setWorks(data);
        setFilterWork(data);
      })
  }, [])

  return (
    <>
      <h2 className='head-text'>
        My Work
        <span> Portfolio </span><br />
        <span> Section </span>
      </h2>
      <div className='app__work-filter'>
        {['WebApp', 'Mobile App', 'Robotics/ROS', 'Computer vision', 'All'].map((item, index) => (
          <div
            key={index}
            onClick={() => handleItem(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'
      >
        {filterWork.map((work, index) => (
          //  { setLink(work.videoUrl)}
          <div className='app__work-item app__flex'
            key={index}>
            <div className='app__work-img app__flex'>
              <img src={urlFor(work.imgUrl)} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.5, ease: 'easeout', staggerChildren: 0.5 }}
                className='app__work-hover app__flex'>

                <a href={work.videoUrl} target='black' rel='noreferrer'>
                  <motion.div
                    whileHover={{ scale: [0, 1] }}
                    whileInView={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >
                    {work.videoUrl === undefined ?
                      <div>Video not Available</div>
                      : <AiFillEye />}
                  </motion.div>
                </a>

                <a href={work.codeLink} target='black' rel='noreferrer'>
                  <motion.div
                    whileHover={{ scale: [0, 1] }}
                    whileInView={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'
                  >

                    <AiFillGithub />

                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className='app__work-content app__flex'>
              <h4 className='bold-txt'>{work.title}</h4>
              <p className='p-text' style={{ marginTop: 10 }}>{work.description}</p>
              <div className='app__work-tag app__flex'>
                <p className='p-text'>{work.tags[0]}</p>
              </div>
            </div>

            <div className='app__work-filter-buttons'>
              {['Video', 'Code'].map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleItem(item)}
                  className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
                >
                  {item === 'Code' ?
                    <motion.div>
                      {work.codeLink === undefined ? <></> :
                        <a href={work.codeLink} target='black' rel='noreferrer'>

                          <motion.div
                            whileHover={{ scale: [0, 1] }}
                            whileInView={{ scale: [1, 0.9] }}
                            transition={{ duration: 0.25 }}
                            className='app__flex'
                          >
                            {item}
                          </motion.div>
                        </a>
                      }
                    </motion.div> :
                    <motion.div>
                      {work.codeLink === undefined ? <></> :
                        <a href={work.videoUrl} target='black' rel='noreferrer'>
                          {console.log("link: ", work.videoUrl)}
                          <motion.div
                            whileHover={{ scale: [0, 1] }}
                            whileInView={{ scale: [1, 0.9] }}
                            transition={{ duration: 0.25 }}
                            className='app__flex'
                          >
                            {item}
                          </motion.div>
                        </a>
                      }
                    </motion.div>
                  }
                </div>
              ))}
            </div>
          </div>
        ))}
      </motion.div>
    </>
  )
}

export default AppWrap(
  MotionWrap(Work, 'app__work'),
  'work', 'app__primarybg')

